import React, {useContext, useState} from 'react';
import AuthContext from "../../Services/AuthContext";
import StyledModal from "../../Component/StyledModal";
import {TextField} from "@mui/material";
import {useParams} from "react-router-dom";


function AddPriority(props) {
    const title = 'Dodaj Pesel';
    const description = 'Tutaj możesz ręcznie dodać pesel do autozapisu.';

    const [user] = useContext(AuthContext);
    const [personalId, setPersonalId] = useState('');
    const params = useParams();

    function _send() {
        const formData = {
            personal_id: personalId
        };
        fetch(`/api/season/${params.id}/priority`, {
            method: 'POST',
            body: JSON.stringify(formData),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(data => {
                props.onSuccess(data);
                props.dismiss();
            })
            .catch(err => { console.log(err) })
    }

    return (<StyledModal isOpen={props.isOpen} title={title} description={description} send={_send} dismiss={props.dismiss}>
                <TextField
                    onChange={(e) => setPersonalId(e.target.value)}
                    label='Pesel'
                    value={personalId}
                    variant="outlined"
                    fullWidth
                />
        </StyledModal>);
}
export default AddPriority;